<template>
  <div id="atert-novo">
    <!-- alert -->
    <div v-if="alert">
          <alert :show.sync="alert.show" placement="top" :duration="alert.duration"
            :type="alert.type" width="350px" dismissable>
            <div class="col-md-2 col-xs-2">
              <i class="fa fa-exclamation-circle fa-3x" v-if="alert.type == 'danger'"
              aria-hidden="true"></i>
              <i class="fa fa-info-circle fa-3x" v-if="alert.type == 'info'"
              aria-hidden="true"></i>
              <i class="fa fa-check-circle fa-3x" v-if="alert.type == 'success'"
              aria-hidden="true"></i>
              <i class="fa fa-exclamation fa-3x" v-if="alert.type == 'warning'"
              aria-hidden="true"></i>
            </div>
            <div class="col-xs-9 col-md-9">
              <strong>{{ alert.title }}</strong>
              <p>{{ alert.message }}</p>
            </div>
          </alert>
    </div>
</div>
</template>
<script>

import alert from './libs/AlertLib.vue'
import { mapState, mapActions } from 'vuex'

export default {

  name: "atert-novo",

  components: {
    alert
  },

  data (){
    return{

    }
  },

  computed: {
    ...mapState('alert', ['alert'])
  }

}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especiais/Alert2.vue